@use "variables" as *;

.imageCreate {
  max-width: 30%;
}
